import BaseComponentController from "./base_component_controller"
import { enter, leave } from "../../../../design_system/transitions"

export default class extends BaseComponentController {
  static targets = ["backdrop", "panel"]

  static values = {
    openClass: { type: String, default: 'open' }
  }

  connect() {
    this.isOpen = false

    if (this.element.classList.contains(this.openClassValue) && !this.isOpen) {
      this.open()
    }
  }

  open(event) {
    this.dispatchEvent({ action: 'before-open' })
    event?.preventDefault()
    this.animateIn()
    this.isOpen = true
    this.dispatchEvent({ action: 'after-open' })
  }

  close(event) {
    this.dispatchEvent({ action: 'before-close' })
    event?.preventDefault()
    this.animateOut()
    this.isOpen = false
    this.dispatchEvent({ action: 'after-close' })
  }

  animateIn() {
    enter(this.element)
    enter(this.backdropTarget)
    enter(this.panelTarget)
  }

  animateOut() {
    leave(this.backdropTarget)
    leave(this.panelTarget)
    leave(this.element)
  }
}

